import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft, Check } from 'lucide-react';
import { motion } from 'framer-motion';

const benefits = [
  'Flexible food choices',
  'Real-world nutrition',
  'No calorie obsession',
  'No macro tracking',
  'Sustainable habits',
  'Long-term results',
];

export default function FlexibleNutrition() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col px-6 pt-12 pb-10 max-w-2xl mx-auto">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm"><ArrowLeft className="w-4 h-4" /> Back</button>

      <div className="mt-8">
        <div className="label-mini text-[var(--c-green-ink)]">Pillar 1 · Nutrition</div>
        <h1 className="font-display font-black text-[40px] md:text-5xl leading-[1.05] mt-3 tracking-tight">
          Flexible Nutrition.
          <br /><span className="text-[var(--c-green-ink)]">Built For Real Life.</span>
        </h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          No restrictive diets. No complicated calorie counting.
        </p>
        <p className="text-muted-foreground mt-2 leading-relaxed">
          YourReGen Protocol teaches you how to build sustainable eating habits using flexible food choices that fit your goals and lifestyle.
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-2.5">
        {benefits.map((b, i) => (
          <motion.div key={i} initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.06 }}
            data-testid={`benefit-${i}`}
            className="regen-card-elevated p-3 flex items-center gap-2.5">
            <div className="w-7 h-7 rounded-full bg-[var(--c-green-soft)] flex items-center justify-center flex-shrink-0">
              <Check className="w-3.5 h-3.5 text-[var(--c-green-ink)]" strokeWidth={3} />
            </div>
            <span className="text-sm font-medium">{b}</span>
          </motion.div>
        ))}
      </div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }} className="mt-8 text-center">
        <div className="font-display font-bold text-xl leading-snug">
          Learn how to <span className="text-[var(--c-green-ink)]">eat for life</span>.
          <br />
          <span className="text-muted-foreground text-base font-normal">Not how to follow another diet.</span>
        </div>
      </motion.div>

      <Button onClick={() => nav('/onboarding/preview')} data-testid="continue-flex-btn" className="mt-auto h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl">
        Continue <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
